export enum TranskodeAudioTrackChannelPosition {
  Lt = "Lt",
  Rt = "Rt",
  L = "L",
  R = "R",
  C = "C",
  LFE = "LFE",
  Ls = "Ls",
  Rs = "Rs",
  Lss = "Lss",
  Rss = "Rss",
  Lrs = "Lrs",
  Rrs = "Rrs",
  Lt_Rt = "Lt_Rt",
  Lt_Rt_C_LFE_Ls_Rs = "Lt_Rt_C_LFE_Ls_Rs",
  Undefined = "Undefined",
}
